import React, { useState } from "react";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { Inertia } from "@inertiajs/inertia";
import { useAtom } from "jotai";
import { createQuestionAtom } from "@/Stores";
import { toast } from "react-toastify";
import { RESET } from "jotai/utils";
import { QuestionBaseForm } from "@/Components/Questions/QuestionBaseForm";
import LayoutIcon from "@/Components/LayoutIcon";
import { Teams as TeamsIcon } from "@/Icons";

export default function CreateQuestion() {
  const [questions, setQuestions] = useAtom(createQuestionAtom);
  const [disabled, setDisabled] = useState(false);

  function handleNewActivity(e, draft = false) {
    setDisabled(true);

    // Transform tags to match the backend
    const tags =
      questions.tags.map((t) => ({
        name: t.label,
        ...(t.value && { id: t.value }),
      })) || [];

    const payload = {
      ...questions,
      tags: tags,
    };

    const id = toast.loading("Please wait...");

    Inertia.post(route("admin.question.store", { draft }), payload, {
      only: ["questionTypes", "errors", "team", "custom_response_data"],
      onSuccess: () => {
        setQuestions(RESET);
        toast.update(id, {
          render: "The question was successfully created!",
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });
      },
      onError: () => {
        toast.update(id, {
          render: "Something went wrong when saving your question",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      },
      onFinish: () => {
        setDisabled(false);
      },
    });

    e.preventDefault();
  }

  return (
    <div className="mb-8">
      <QuestionBaseForm atom={createQuestionAtom} showReporterSelect={false} />

      <div className="flex w-full flex-row justify-end gap-4">
        <button
          className="btn-blue-outline flex-grow-0"
          onClick={(e) => handleNewActivity(e, true)}
        >
          Save as draft
        </button>
        <button
          disabled={disabled}
          className="btn btn-blue flex-grow-0"
          onClick={handleNewActivity}
        >
          Create activity
        </button>
      </div>
    </div>
  );
}

CreateQuestion.layout = (page) => {
  const backAction = () => {
    const backUrl = route("admin.question");
    const previousUrl = page.props?.previous_url;
    const [previousPath] = previousUrl.split("?");

    if (backUrl === previousPath && window.history.length > 1) {
      window.history.back();
    } else {
      Inertia.visit(backUrl);
    }
  };

  return (
    <AppLayout title="Add new global activity">
      <OrganizationLayout
        header="Add new global activity"
        backAction={{ label: "Back", callback: backAction }}
        icon={
          <LayoutIcon>
            <TeamsIcon size={40} className="text-black" />
          </LayoutIcon>
        }
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  );
};
